export default __webpack_public_path__ + "static/media/trip-to-nowhere.07be8ce9.jpg";